import { render, staticRenderFns } from "./figments.vue?vue&type=template&id=35551e9c&"
import script from "./figments.vue?vue&type=script&lang=js&"
export * from "./figments.vue?vue&type=script&lang=js&"
import style0 from "./figments.vue?vue&type=style&index=0&id=35551e9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports